import styled from "styled-components";
import { colors } from "../../theme/theme";

export const RatingContainer = styled.div`
  width: 100%;
  display: flex;
  font-size: 1.25rem;
  color: ${colors.magenta};
`;
